import { createSlice } from '@reduxjs/toolkit'
import {getUserData, postLogin} from "./thunks"

const initialState= { 
  user: {
    user: {},
  }, 
  loading: "idle",
  loadingUserData: "idle",
  error: null }

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    logOut: (state)=> initialState
  },
  extraReducers: 
  builder => {
    builder.addCase(postLogin.pending, (state) => {
      state.loading = "loading"; 
      //state.loadingUserData = "loading"; 
        state.error = null
    })
    builder.addCase(postLogin.fulfilled, (state, action) => {
      state.loading = "succeeded";
      //state.loadingUserData = "succeeded";
      state.user = action.payload
    })
    builder.addCase(postLogin.rejected, (state, action) => {
      state.loading = "failed"; 
      //state.loadingUserData = "failed"; 
      state.error = action.error.message
    })
    builder.addCase(getUserData.pending, (state) => {
      state.loadingUserData = "loading"; 
        state.error = null
    })
    builder.addCase(getUserData.fulfilled, (state, action) => {
      state.loadingUserData = "succeeded";
      state.user.user = action.payload
    })
    builder.addCase(getUserData.rejected, (state, action) => {
      state.loadingUserData = "failed"; 
      state.error = action.error.message
    })
  }
 
})

export {authenticationSlice}
export const {logOut} = authenticationSlice.actions
export default authenticationSlice.reducer
